var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
import { SpawnSchema } from "./components/entity/Spawn.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let SpawnOnTimeoutSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "timeElapsed");
    __publicField(this, "timeout");
    __publicField(this, "timedOut");
    __publicField(this, "spawn");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], SpawnOnTimeoutSchema.prototype, "timeElapsed", 2);
__decorateClass([
  type("number"),
  defaultValue(1e3)
], SpawnOnTimeoutSchema.prototype, "timeout", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], SpawnOnTimeoutSchema.prototype, "timedOut", 2);
__decorateClass([
  type([SpawnSchema]),
  defaultValue([])
], SpawnOnTimeoutSchema.prototype, "spawn", 2);
SpawnOnTimeoutSchema = __decorateClass([
  Component("SpawnOnTimeout")
], SpawnOnTimeoutSchema);
let MultiSpawnOnTimeoutSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "timeouts");
  }
};
__decorateClass([
  type([SpawnOnTimeoutSchema]),
  defaultValue([])
], MultiSpawnOnTimeoutSchema.prototype, "timeouts", 2);
MultiSpawnOnTimeoutSchema = __decorateClass([
  Component("MultiSpawnOnTimeout")
], MultiSpawnOnTimeoutSchema);
const __vite_glob_0_35 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get MultiSpawnOnTimeoutSchema() {
    return MultiSpawnOnTimeoutSchema;
  },
  get SpawnOnTimeoutSchema() {
    return SpawnOnTimeoutSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  MultiSpawnOnTimeoutSchema as M,
  SpawnOnTimeoutSchema as S,
  __vite_glob_0_35 as _
};
//# sourceMappingURL=SpawnOnTimeoutComponent-0dd66b5e.js.map
